
import { createLogger, format, transports } from 'winston'
import { DatadogTransport } from './winston-datadog'
import { fullFormat } from 'winston-error-format'
import stringify from 'json-stringify-safe'
import {DATADOG_TOKEN, IS_DEV, LOG_LEVEL} from "@/constants";
import {GameGlassUser} from "@/hooks/useCurrentUser";

// Polyfill because winston uses an old API
// @ts-ignore we know it's not there...
if (!window.setImmediate) {
	// @ts-ignore for some reason, it's trying to use node's setImmediate function type...
	window.setImmediate = (callback) => {
		setTimeout(callback, 0)
	}
}

const privateFormatter = format((info) => {
	const clean = (data: any, depth = 0) => {
		Object.keys(data).forEach((key) => {
			if (key.startsWith('_')) {
				delete data[key]
			} else if (depth < 5 && data[key] && typeof data[key] === 'object') {
				data[key] = clean(data[key], depth++)
			}
		})
		return data
	}

	return clean(info)
})

const axiosFormatter = format((info) => {
	const clean = (data: any) => {
		if (data.name === 'AxiosError') {
			return {
				name: data.name,
				code: data.code,
				config: data.config
			}
		}
		if (data?.config && data?.headers && data?.request) {
			delete data.request
			// Axios response object
			if (data.config.headers?.['content-length'] > 10000) {
				data.config.data = 'Data too large'
			}

			if (data.headers?.['content-length'] > 10000) {
				data.data = 'Data too large'
			}
		}
		return data
	}

	;['response', 'result', 'error'].forEach((key) => {
		if (info?.[key]) {
			info[key] = clean(info[key])
		}
	})
	return clean(info)
})

const datadog = new DatadogTransport(DATADOG_TOKEN, 'frontend')
export const logger = createLogger({
	level: LOG_LEVEL || 'info',
	format: format.combine(
		fullFormat(),
		privateFormatter(),
		axiosFormatter(),
		format.timestamp({
			format: 'YYYY-MM-DD HH:mm:ss'
		}),
		format.printf((info) => {
			try {
				const stringifiedRest = stringify({
					...info,
					level: undefined,
					message: undefined,
					splat: undefined,
					timestamp: undefined
				})
				if (stringifiedRest !== '{}') {
					return `[${(info as any).timestamp}][${info.level}]: ${info.message} ${stringifiedRest}`
				}
				return `[${(info as any).timestamp}][${info.level}]: ${info.message}`
			} catch (_err) {
				// Do nothing
			}
			return ''
		})
	),
	handleExceptions: true,
	handleRejections: true,
	exitOnError: false,
	transports: [datadog],
	defaultMeta: {
		version: import.meta.env.PACKAGE_VERSION
	}
})

if (IS_DEV) {
	logger.add(new transports.Console())
}

console.error = logger.error = logger.error.bind(logger)
console.warn = logger.warn = logger.warn.bind(logger)
console.info = logger.info = logger.info.bind(logger)
console.debug = logger.debug = logger.debug.bind(logger)
console.log = logger.debug = logger.debug.bind(logger)

export const setLoggerUser = (user?: Partial<GameGlassUser>, clerkUser?: { id?: string } | null) => {
	datadog.setUserId(user?.id?.toString(), clerkUser?.id?.toString())
}
